var render = function render(){var _vm=this,_c=_vm._self._c,_setup=_vm._self._setupProxy;return _c('div',{staticClass:"breakdance-variables-panel-content"},[_c('GlobalVariablesInput',{attrs:{"value":_vm.variables},on:{"input":_vm.updateVariables}})],1)
}
var staticRenderFns = []

export { render, staticRenderFns }